import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import useQueryString from "@store/Framework/Common/Hooks/useQueryString";
import { shallowEqual, useSelector } from "react-redux";

const usePromotions = (options?: Toolkit.GoogleAnalytics.Options) => {
    const { cartId } = useQueryString();

    return useSelector(
        (state: ApplicationState) => getPromotionsDataView(state, cartId || API_URL_CURRENT_FRAGMENT).value,
        shallowEqual,
    );
};

export default usePromotions;
